module.exports = __webpack_public_path__ + "static/pitch_nights_stripe-fb464229f425850c1b5f36c853594913.jpg";